import styled, { css } from 'styled-components'

export const Container = styled.div<{
  buttonsQty: number
  autoArrangeWidth?: boolean
}>`
  display: flex;
  margin: 20px 0 0;
  user-select: none;
  justify-content: ${props => props.autoArrangeWidth ? 'center' : 'flex-start'};
  ${props => (props.buttonsQty > 1) && css`
    justify-content: ${props.autoArrangeWidth ? 'space-between' : 'flex-start'};

    @media (max-width: 1023px) {
      display: block;
    }

    > button {
      min-width: 170px;
      width: ${props.autoArrangeWidth ? 'calc(50% - 10px)' : 'auto'};
      margin: ${!props.autoArrangeWidth ? '0 10px 0 0' : '0'};

      @media (max-width: 1023px) {
        width: 100%;
        margin: 0;

        &:first-child {
          margin: 0 0 15px;
        }
      }
    }
  `}
`
